import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import useMasterContext from "Context/MasterContext";
import {
  DataObject,
  getMonthsBetweenDates,
  returnDateString,
} from "Pages/Faculties/FacultiesMain";
import FacultyHealthHeader from "Pages/Faculties/FacultyHealthHeader";
import FacultiesBranchesHeader from "Pages/FacultiesAntd/Branches/FacultiesBranchesHeader";
import {
  aggregatedorder,
  processResponseForCardData,
} from "Pages/FacultiesAntd/Regions/FacultiesRegions";
import FacultiesRegionsTable from "Pages/FacultiesAntd/Regions/FacultiesRegionsTable";
import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  BASE_URL,
  FacultyPerformance,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";

const FacultiesBranches = () => {
  const { screen }: any = useWindowSize();
  const location = useLocation();
  const userInfo = useContext<any>(UserInfoContext);
  const { masters } = useMasterContext();
  const { facultyPerformance } = useContext(FacultyPerformanceContext);
  const [open, setOpen] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    chipFields: {},
  });
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50", "100"],
    showSizeChanger: true,
    current: 1,
    sortField: "branchOrRegionName",
    sortOrder: "ASC",
  });
  const ToastDispatch = useContext(ToastContextDispatch);
  const currentMonth = dayjs().startOf("month");
  const nextMonth = dayjs().endOf("month");
  const [dates, setDates] = useState<any>([currentMonth, nextMonth]);
  const [branchData, setBranchData] = useState<any>([]);
  const [cardAggregatedData, setCardAggregatedData] = useState<any>(null);
  const { makeRequest: GetBranchData, loading: tableloading } = useGetApi(
    (data) => {
      if (
        data["data"] &&
        data["data"] &&
        data["data"]["facultyFeedbackResponse"]
      ) {
        setOpen(false);
        setBranchData(data["data"]["facultyFeedbackResponse"] || []);
        setPagination({
          ...pagination,
          total: data?.totalCount,
        });
        const aggredatedDataList = data["data"]["facultyOverAllCardDetails"];
        const reorderedData: DataObject = {};
        aggregatedorder.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(aggredatedDataList, key)) {
            reorderedData[key] = aggredatedDataList[key];
          }
        });
        setCardAggregatedData(reorderedData);
      } else {
        setBranchData([]);
      }
    },
    (error) => {
      setBranchData([]);
      setOpen(false);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    const offset = (pagination.current - 1) * pagination.pageSize;
    const limit = pagination.pageSize;
    const filterLength = Object.values(filterState).filter(
      (ele) => ele != null
    ).length;
    if (Object.keys(facultyPerformance).length) {
      applyFilter(facultyPerformance);
    } else {
      if (masters.streams && masters.streams[0] != undefined) {
        const streamId = masters.streams[0]?.value;
        let url =
          BASE_URL +
          FacultyPerformance +
          "?sortBy=" +
          pagination.sortField +
          "&sortDir=" +
          pagination.sortOrder;
        url = url + "&fetchAllRegions=true";
        if (filterLength) {
          applyFilter(filterState);
        } else {
          GetBranchData(
            `${url}&limit=${limit}&offset=${offset}&streamIds=${streamId}&yearMonth=${returnDateString(
              dates[0]
            )}`
          );
        }
      }
    }
  }, [
    masters.streams,
    pagination.current,
    pagination.pageSize,
    pagination.sortOrder,
  ]);
  useEffect(() => {
    if (Object.keys(facultyPerformance).length) {
      const obj = {
        ...filterState,
        subject: facultyPerformance?.subject,
        streamIds: facultyPerformance?.streamIds,
        yearMonth: facultyPerformance?.yearMonth,
        chipFields: {
          streamIds: facultyPerformance?.streamIds,
          yearMonth: facultyPerformance?.yearMonth,
        },
      };
      if (facultyPerformance?.subject) {
        obj["chipFields"]["subject"] = facultyPerformance?.subject;
      }
      setFilterState(obj);
      setDates(facultyPerformance?.yearMonth);
    } else {
      setFilterState({
        streamIds:
          userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        yearMonth: dates,
        chipFields: {
          streamIds:
            userInfo?.userStreams && userInfo?.userStreams[0] != undefined
              ? userInfo?.userStreams[0]
              : null,
          yearMonth: dates,
        },
      });
    }
  }, [masters.streams, facultyPerformance]);
  const applyFilter = (filterStateObj: any) => {
    const limit = pagination.pageSize;
    const offset = (pagination.current - 1) * pagination.pageSize;
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        streamIds: filterStateObj.streamIds
          ? filterStateObj.streamIds.value
          : masters.streams[0].value,
        subject: filterStateObj.subject?.value,
        yearMonth:
          filterStateObj.yearMonth && filterStateObj.yearMonth.length > 0
            ? getMonthsBetweenDates(
                filterStateObj.yearMonth[0],
                filterStateObj.yearMonth[1]
              )
            : returnDateString(dates[0]),
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + FacultyPerformance;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      } else {
        url = url + "?";
      }
      url =
        url +
        "&sortBy=" +
        pagination.sortField +
        "&sortDir=" +
        pagination.sortOrder;

      const regionId =
        location.pathname.split("/")[location.pathname.split("/").length - 1];
      url = url + `&regionCode=${regionId}`;
      GetBranchData(`${url}&limit=${limit}&offset=${offset}`);
    }
  };
  const extraInformation = {
    branchAndRegionIdentifier: false,
    regionId:
      location.pathname.split("/")[location.pathname.split("/").length - 1],
    streamId: filterState.streamIds,
  };
  return (
    <StyledMainDiv screen={screen}>
      <FacultiesBranchesHeader
        setFilterState={setFilterState}
        filterState={filterState}
        open={open}
        setOpen={setOpen}
        dates={dates}
        setDates={setDates}
        applyFilter={applyFilter}
        pagination={pagination}
        mode="Branch"
        extraInformation={extraInformation}
      ></FacultiesBranchesHeader>
      <FacultyHealthHeader
        mode="regionFaculties"
        aggregatedDataLoading={tableloading}
        aggregatedData={processResponseForCardData(cardAggregatedData, [])}
      />
      <TableLayoutAntd isLoader={false}>
        <FacultiesRegionsTable
          data={branchData}
          pagination={pagination}
          setPagination={setPagination}
          mode="Branch"
          extraInformation={extraInformation}
        ></FacultiesRegionsTable>
      </TableLayoutAntd>
    </StyledMainDiv>
  );
};

export default FacultiesBranches;
